module.exports = __webpack_public_path__ + "img/money_with_wings.2f2f6f9b.gif";